export const GET_SEANCES_REQUEST = 'GET_SEANCES_REQUEST' as const;
export const GET_SEANCES_SUCCESS = 'GET_SEANCES_SUCCESS' as const;
export const GET_SEANCES_FAIL = 'GET_SEANCES_FAIL' as const;

export const RESET_SEANCES = 'RESET_SEANCES' as const;
